import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../../AuthContext';

/**
 * Preferências da casca (menu e densidade), por usuário.
 *
 * Ficam no navegador (localStorage), chaveadas pelo usuário: cada pessoa tem a sua
 * neste aparelho. Guardar na conta, para valer em outro aparelho, depende de um
 * endpoint de preferências que ainda não existe.
 */
const PADROES = { navegacao: 'lateral', densidade: 'compacta' };
const OPCOES = { navegacao: ['lateral', 'superior'], densidade: ['compacta', 'confortavel'] };
const EVENTO = 'sj-preferencia-casca';

function chave(nome, usuarioId) {
  return `sj_pref_${nome}_${usuarioId ?? 'anonimo'}`;
}

function ler(nome, usuarioId) {
  try {
    const valor = localStorage.getItem(chave(nome, usuarioId));
    return OPCOES[nome].includes(valor) ? valor : PADROES[nome];
  } catch (_) {
    return PADROES[nome];
  }
}

/**
 * Lê e troca uma preferência da casca. Todas as partes da tela que usam o mesmo
 * nome recebem a troca na hora (evento na janela), sem recarregar.
 */
export function usePreferenciaCasca(nome) {
  const { usuarioLogado } = useAuth();
  const usuarioId = usuarioLogado?.id;
  const [valor, setValor] = useState(() => ler(nome, usuarioId));

  useEffect(() => {
    setValor(ler(nome, usuarioId));
  }, [nome, usuarioId]);

  useEffect(() => {
    const aoMudar = (e) => {
      if (e.detail.nome === nome) setValor(e.detail.valor);
    };
    window.addEventListener(EVENTO, aoMudar);
    return () => window.removeEventListener(EVENTO, aoMudar);
  }, [nome]);

  const alterar = useCallback((novo) => {
    if (!OPCOES[nome].includes(novo)) return;
    try {
      localStorage.setItem(chave(nome, usuarioId), novo);
    } catch (_) {
      // Sem armazenamento, a escolha vale só nesta página.
    }
    window.dispatchEvent(new CustomEvent(EVENTO, { detail: { nome, valor: novo } }));
  }, [nome, usuarioId]);

  return [valor, alterar];
}
